import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/amangeldi.jpg";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";

export const PersonAmangeldi = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}>Амангелді Мағжан Айтмұратұлы</MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Bachelor of Industrial Automation, Master of Sciences in Electrical and Computer Engineering, PhD Student of Astana IT University
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={12} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://orcid.org/0009-0002-7979-0502'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>ТОО «Astana IT University», младший научный сотрудник, НИЦ «Industry 4.0». Стаж по профилю — 2 года.</MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте</MyText>
                <MyText size={"small"} italic>Младший научный сотрудник / Разработчик</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка нейросетевых моделей (LSTM, CNN) для классификации уровней утомления и прогнозирования рисков;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Спектральный анализ биосигналов (FFT, HRV) для оценки состояния вегетативной нервной системы;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Интеграция ИИ в IoT-архитектуру: предиктивные алгоритмы в облачных и мобильных сегментах системы;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Анализ временных рядов: модели оценки готовности к нагрузкам (Readiness Score) и раннего обнаружения аномалий.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Докторант по специальности «Искусственный интеллект» по теме «Разработка интеллектуальных методов динамического выявления исследовательских трендов на основе глубоких моделей обработки естественного языка и анализа научных сетей». Опыт в построении, обучении и оценке моделей машинного обучения, анализе данных, разработке алгоритмов прогнозирования. Владение Python, MATLAB, PyTorch, Scikit-learn, TensorFlow.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR24993128 «ИАС трансграничных водных ресурсов» (2024-2026), исполнитель.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Публикации:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    1. Biloshchytskyi, Neftissov, Kazambayev, Amangeldi, Kirichenko, Medetkhan. Correlation-Matrix–Driven Diagnostics of Industrial Emissions. Scientific Journal of Astana IT University, 24, 2025.
                </MyText>
            </Flex>
        </Flex>
    );
};
